import { ARC_ENVIRONMENT } from '@arc/shared/data-arc-env';
import { ms } from '@arc/shared/util-js';
const isProd = ARC_ENVIRONMENT === 'prod';
export const WARNING_TIMEOUT_MS = 1 * ms.minutes;
export const IDLE_TIMEOUT_MS = isProd ? 15 * ms.minutes : 60 * ms.minutes;